export enum QuestionnaireFilterType {
    ALL = 'all',
    INCIDENT = 'incident',
    COMPLIMENT = 'compliment',
    DIRECT = 'direct'
}
